import * as Sentry from '@sentry/react'

let reportErrorInternal
let reportErrorMessageWithDataInternal

/**
 * Isomorphic mutation of the error reporting handlers based on build target.
 *
 * Note: Stringifying the errors makes them a little more difficult to read, but prevents
 * Datadog from counting each line of these errors as a separate error
 *
 */

declare const IS_SSR_ENGINE: boolean

if (IS_SSR_ENGINE) {
  reportErrorInternal = (message?: string, err?: object, data?: object) => {
    const { logger } = require('src/server/logging')
    logger().error({
      message: message,
      error: err ? JSON.stringify(err) : 'error absent',
      data: data ? data : {}
    })
    Sentry.captureException(err || message)
  }
  reportErrorMessageWithDataInternal = (message: string, extra?: object) => {
    const { logger } = require('src/server/logging')
    logger().error({
      message: message,
      data: extra ? extra : {}
    })
    Sentry.captureMessage(message, {
      level: 'error',
      extra: { ...extra }
    })
  }
} else {
  reportErrorInternal = (message?: string, err?: object, data?: object) => {
    console.error(message, JSON.stringify(err), JSON.stringify(data))
    Sentry.captureException(err || message)
  }
  reportErrorMessageWithDataInternal = (message: string, extra?: object) => {
    console.error(message, JSON.stringify(extra))
    Sentry.captureMessage(message, {
      level: 'error',
      extra: { ...extra }
    })
  }
}

/**
 * Generic error handler. This error handler can be extended to hook into error reporting tools like Sentry.
 * Unlike src/lib/js/error.js, this file is webpack/browser compatible.
 *
 * @param {string} message - The error message to report.
 * @param {object} err - The error object to report. OPTIONAL.
 * @param {object} data - A custom data object to report. OPTIONAL.
 */
export const reportError = reportErrorInternal

/**
 * Generic error handler. This error handler can be extended to hook into error reporting tools like Sentry.
 * Unlike src/lib/js/error.js, this file is webpack/browser compatible.
 *
 * @param {string} message - The error message to report.
 * @param {object} data - A custom data object to report. OPTIONAL.
 */
export const reportErrorMessageWithData = reportErrorMessageWithDataInternal
